module.exports = __webpack_public_path__ + "b7f7d1c694e118afbd5dfa78a278113b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-32.png
// module id = 3158
// module chunks = 0